import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { cajasAPI } from '../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import '../Clientes.css';

const Cajas = () => {
  const [cajas, setCajas] = useState([]);
  const [loading, setLoading] = useState(true);
  const { hasPermission } = useAuth();

  useEffect(() => {
    loadCajas();
  }, []);

  const loadCajas = async () => {
    try {
      setLoading(true);
      const response = await cajasAPI.getAll({});
      if (response.success) {
        setCajas(response.data);
      }
    } catch (error) {
      toast.error('Error al cargar cajas');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Está seguro de eliminar esta caja?')) return;

    try {
      const response = await cajasAPI.delete(id);
      if (response.success) {
        toast.success('Caja eliminada exitosamente');
        loadCajas();
      }
    } catch (error) {
      toast.error(error.message || 'Error al eliminar caja');
    }
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  return (
    <div className="clientes pagina-listado pagina-listado--scroll">
      <div className="page-header">
        <h1>Cajas</h1>
        {hasPermission('crear_debitos') && (
          <Link to="/cajas/nuevo" className="btn-primary">+ Nueva Caja</Link>
        )}
      </div>

      <div className="listado-panel clientes-listado listado-controles">
        <div className="listado-panel-cuerpo clientes-listado-cuerpo">
          <div className="listado-tabla-area clientes-listado-tabla-area">
            <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Saldo inicial</th>
              <th>Moneda</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {cajas.length === 0 ? (
              <tr>
                <td colSpan="6" className="no-data">No hay cajas registradas</td>
              </tr>
            ) : (
              cajas.map(caja => (
                <tr key={caja.id}>
                  <td><strong>{caja.nombre}</strong></td>
                  <td>{caja.descripcion || '-'}</td>
                  <td>${parseFloat(caja.saldo_inicial || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}</td>
                  <td>{caja.moneda || 'ARS'}</td>
                  <td>
                    <span className={`badge ${caja.activa ? 'activo' : 'inactivo'}`}>
                      {caja.activa ? 'Activa' : 'Inactiva'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      {hasPermission('cerrar_caja') && (
                        <Link to={`/cierre-caja?caja_id=${caja.id}`} className="btn-edit">Cerrar caja</Link>
                      )}
                      {hasPermission('crear_debitos') && (
                        <>
                          <Link to={`/cajas/editar/${caja.id}`} className="btn-edit">Editar</Link>
                          <button onClick={() => handleDelete(caja.id)} className="btn-delete">Eliminar</button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cajas;
